import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Path from '../constants/path';
import {useDispatch, useSelector} from 'react-redux';
import makeApiCall from '../api/makeApiCall';
import {logoutApi, roleData} from '../api/request/loginApi/loginApi';
import Strings from '../constants/stringConstant';
import {resetAllLocValues} from '../state/slice/locationSlice';
import {logout} from '../state/slice/userSlice';
import {resetPayLoadValue} from '../state/slice/leadListPayloadSlice';
import {clearLeadValue} from '../state/slice/leadSlice';
import {resetMccValue} from '../state/slice/mccListSlice';
import {resetFilterValue} from '../state/slice/filterSlice';
import {resetPlatformPayLoadValue} from '../state/slice/platformListPayloadSlice';
import {resetLoanPayLoadValue} from '../state/slice/loanListPayloadSlice';
import {toast} from 'react-toastify';
import {setRbacValue} from '../state/slice/rbacSlice';
import {getUserData, logoutFunction} from '../utils/appUtils';
import SuccessModal from '../components/Modal/successModal';
import {useTranslation} from 'react-i18next';
import {IdleTimerProvider} from 'react-idle-timer';

import {resetAllEligibilityCheck} from '../state/slice/EligibilitySlice';
import {fetchUserProductCategories} from '../api/request/masterFetchApi/masterFetchApi';
import {
  clearProductIdValue,
  setProductIdValue,
} from '../state/slice/productFilterSlice';

const RedirectOnRefresh = WrappedComponent => {
  const RedirectOnRefreshComponent = props => {
    const [callLogout, setCallLogout] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isAuthenticated = sessionStorage.getItem('isLoggedIn');
    const roleId = getUserData();
    const TimeOutTime = roleId?.inactivityTimeout * 60 * 1000 || 450000;
    console.log(roleId, 'roleId');
    const {productCasbinKey} = useSelector(state => state.productFilterSlice);
    const {loanProduct} = useSelector(state => state.loanSearchProduct);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const {applicationType} = useSelector(state => state.loanListPayload);

    const {t: translator} = useTranslation();
    useEffect(() => {
      if (sessionStorage.getItem('isIdle') === 'true' && roleId?.userId) {
        sessionStorage.removeItem('isIdle');
        setTimeout(() => {
          logoutFunction(dispatch, roleId?.userId, navigate);
        }, [1000]);
      }
    }, [callLogout, dispatch, roleId?.userId, navigate]);
    const handleOnIdle = async () => {
      setCallLogout(true);

      if (isAuthenticated) {
        sessionStorage.setItem('isIdle', 'true');
        alert(
          `${Strings.idleTimeMessage} ${roleId?.inactivityTimeout} ${Strings.idleTimeMessageTwo} `,
        );
      }
    };

    useEffect(() => {
      if (!isAuthenticated) {
        navigate('/login');
      } else {
        fetchProducts();
      }
      // window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        // window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }, [isAuthenticated]);

    const fetchProducts = async () => {
      let response = await makeApiCall(fetchUserProductCategories({}));
      if (response?.data?.status === Strings?.success) {
        const products = response?.data?.data;
        // if (products && products?.length > 0) {
        fetchRoleData(products[0]?.casbinKey);
        dispatch(setProductIdValue(products[0]?.productId));
        // } else {
        //   dispatch(clearProductIdValue());
        // }
      } else {
        dispatch(clearProductIdValue());
      }
    };

    const fetchRoleData = async product => {
      try {
        const payload = {
          roleId: roleId?.role,
          domain: 'web',
          product:
            productCasbinKey ||
            (applicationType === 'Loan Search'
              ? loanProduct?.casbinKey
              : null) ||
            product,
        };

        const response = await makeApiCall(roleData(payload));
        if (response?.data?.status === Strings.success) {
          const responseValue = JSON.parse(response?.data?.data?.permission);

          dispatch(setRbacValue({roleBased: responseValue}));

          // Mapping of module to Path
          const moduleToPath = {
            lead: Path.lead_management,
            mcc: Path.mcc_management,
            platform: Path.platform_management,
            masters: Path.masters_role_master,
            logs: Path.api_logs,
            configurations: Path.configuration,
            reassignment: Path.manage_reassign,
            loan_search: Path.loan_search,
            template_engine: Path.template_engine,
            reports: Path.reports,
            customer360: Path.customer360,
          };

          // List of submodules that belong to loan_application
          const loanSubmodules = [
            'qde',
            'dde',
            'field_investigation',
            'approval_flow',
            'review_and_fi',
            'eligibility_check_and_cam',
            'personal_discussion',
            'partner_approval',
            'loan_booking',
            'document_verification',
            'document_execution',
            'disbursement',
            'order_confirmation',
          ];

          const keys = Object.keys(responseValue);

          // Step 1: Check if ANY loan submodule exists
          const hasLoanPermission = keys.some(id =>
            loanSubmodules.includes(id),
          );

          if (hasLoanPermission) {
            navigate(Path.loan_application);
            return;
          }

          // Step 2: Otherwise go to the FIRST non-loan module
          for (const key of keys) {
            if (loanSubmodules.includes(key)) {
              continue; // skip loan submodules
            }
            if (moduleToPath[key]) {
              navigate(moduleToPath[key]);
              return;
            }
          }

          // Step 3: If nothing matched → logout modal
          setShowLogoutModal(true);
          setTimeout(() => {
            handleLogout();
          }, 2000);
        } else if (response?.data?.status === Strings.error) {
          console.log('failed:');
        }
      } catch (error) {
        toast.error(Strings.apiError, {
          position: 'top-right',
        });
        console.log('failed:', error);
      }
    };

    const handleLogout = async () => {
      const response = await makeApiCall(
        logoutApi({
          userId: roleId?.userId,
          remarks: Strings?.logout,
        }),
      );
      if (response?.data?.status === Strings?.success) {
        dispatch(resetAllLocValues());
        dispatch(logout());
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('auth_token');
        dispatch(resetPayLoadValue());
        dispatch(clearLeadValue());
        dispatch(resetMccValue());
        dispatch(resetFilterValue());
        dispatch(resetPlatformPayLoadValue());
        dispatch(resetLoanPayLoadValue());
        dispatch(resetAllEligibilityCheck());
        setTimeout(() => {
          navigate(Path.login);
        }, 400);
      } else {
        let errorCode = response?.data?.error?.errorCode;
        let errorMessage = translator(`ErrorMessages.${errorCode}`);

        if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
          errorCode = 'SAMASTA001';
          errorMessage = translator('ErrorMessages.SAMASTA001');
        }

        if (response?.data?.error?.errorCode !== 'SAMASTA015') {
          toast.error(errorMessage);
        }
      }
      setShowLogoutModal(false);
    };

    return (
      <>
        <IdleTimerProvider timeout={TimeOutTime} onIdle={handleOnIdle}>
          <WrappedComponent {...props} />
        </IdleTimerProvider>
        <SuccessModal
          open={showLogoutModal}
          onClose={() => {
            setTimeout(() => {
              setShowLogoutModal(false);
            }, 2000);
          }}
          reject={true}
          message="Logging out"
          subMessage="There is no Permission for this account"
        />
      </>
    );
  };

  // const handleBeforeUnload = event => {
  //   const message =
  //     'Are you sure you want to leave? Changes you made may not be saved.';
  //   event.returnValue = message; // Standard for most browsers
  //   event.preventDefault();
  // };

  RedirectOnRefreshComponent.displayName = `RedirectOnRefresh(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return RedirectOnRefreshComponent;
};

export default RedirectOnRefresh;
